import React from 'react';

import { getClickAttrs } from '../../Analytics/gtag';
import { clickCategories, clickLocations } from '../../../utils/analytics';
import { navigationIDs } from '../../Analytics/testIDConfig';
import BackgroundImage from '../../BackgroundImage';

import styles from '../header.scss';

const DesktopToggleMenu = ({ authUser, onClick }) => {
    return (
        <div
            className={`${styles.hamburger} ${authUser ? styles.authed : ''}`}
            onClick={onClick}
            data-testid="header.desktop-toggle-menu"
            {...getClickAttrs({
                category: clickCategories.HEADER,
                context: `Toggle Menu`,
                location: clickLocations.HEADER_CTA,
                testid: `${navigationIDs.toggleMenuAuth.component}-${navigationIDs.toggleMenuAuth.location}-${navigationIDs.toggleMenuAuth.id}`,
            })}
        >
            <span className="sr-only">Toggle Menu</span>
            <div className="d-flex flex-row align-items-center">
                <BackgroundImage
                    baseUrl={'/v1/player/'}
                    defaultImage={'/img/v2/icons/icon-profile.svg'}
                    images={authUser?.claimedPlayer ? authUser.claimedPlayer.playerProfileImages : null}
                    imageType={'thumbnail'}
                    parentStylesClass={'avatar'}
                />
            </div>
        </div>
    );
};

export default DesktopToggleMenu;
